"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.IllnessPopup = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _specifiedIllness = require("../../specifiedInjuries/specifiedIllness");
var _popupContentList = require("./popupContentList");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var IllnessPopup = exports.IllnessPopup = function IllnessPopup(_ref) {
  var productDefinition = _ref.productDefinition,
    onPopupClose = _ref.onPopupClose;
  var petSpecies = productDefinition.petSpecies;
  var contentBase = _specifiedIllness.specifiedIllnessDogBase;
  var contentList = _specifiedIllness.specifiedIllnessDefaultDogList;
  if (petSpecies && !petSpecies.includes('CANINE')) {
    contentBase = _specifiedIllness.specifiedIllnessCatBase;
    contentList = _specifiedIllness.specifiedIllnessDefaultCatList;
  }
  var _contentBase = contentBase,
    _contentBase$default$ = _contentBase["default"].header,
    title = _contentBase$default$.title,
    subtitle = _contentBase$default$.subtitle;
  return /*#__PURE__*/_react["default"].createElement(_components.Panel, {
    size: "small",
    open: true,
    onClose: onPopupClose,
    type: "modal",
    modalLabel: "Specified illnesses popup",
    header: {
      fixed: true,
      content: title
    }
  }, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("strong", null, title), " ", subtitle), /*#__PURE__*/_react["default"].createElement(_popupContentList.PopupContentList, {
    listDefinition: contentList
  }));
};
IllnessPopup.propTypes = {
  /* eslint-disable-next-line react/forbid-prop-types */
  productDefinition: _propTypes["default"].any,
  onPopupClose: _propTypes["default"].func
};
var _default = exports["default"] = {
  IllnessPopup: IllnessPopup
};